// extracted by mini-css-extract-plugin
export var errorIcon = "_o8-1";
export var nameLogo = "_o8-0";